/*
  Cart quantities that always show what the cart holds — drawer and cart page.

  Dawn's cart.js changes a line by its POSITION ("line 2 → 4"). On this store that position
  moves under the shopper's finger: the free-gift sync puts its gift line at the top of the
  cart, and Shopify splits one piece into two lines when a discount settles on part of its
  quantity (4 became 1 + 3, each with a new key). A "+" tapped on a drawer drawn a moment
  earlier then landed on the wrong line, or on a line that no longer existed, and the screen
  showed something other than the cart until a reload.

  So here every change:
  - names the PIECE (its variant and properties), not a position, and sets the piece's TOTAL
    quantity — the cart is read fresh just before, so splits and gifts cannot mislead it;
  - waits its turn: one cart write at a time, the gift sync included (window.kkCart.queue);
  - answers with the drawer, the bag count and the cart page drawn from that same reply.
  Taps made while a write is under way are not blocked: the last value wins, and the
  quantity box keeps showing it until its own answer comes back.

  Loaded after assets/cart.js (snippets/cart-drawer.liquid, sections/main-cart-items.liquid).
*/
(function () {
  'use strict';
  if (window.kkCart || typeof CartItems === 'undefined') return;

  var RENDER_FLAG = 'kk_render=1';
  var GIFT_FLAG = 'kk_gift=1';
  var pending = new Map(); // a piece (data-group) -> the quantity tapped, shown until its answer arrives
  var chain = Promise.resolve();

  function queue(task) {
    var run = chain.then(task, task);
    chain = run.catch(function () {});
    return run;
  }

  function isGift(item) {
    return !!(item.properties && (item.properties._gift === 'true' || item.properties._gift === true));
  }

  function sameProperties(a, b) {
    return JSON.stringify(a.properties || {}) === JSON.stringify(b.properties || {});
  }

  function sectionIds() {
    var ids = [];
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (foot && foot.dataset.id) ids.push(foot.dataset.id);
    ids.push('cart-live-region-text');
    return ids;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(
        function (json) { return { ok: res.ok, json: json }; },
        function () { return { ok: false, json: {} }; }
      );
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function parse(html) {
    return html ? new DOMParser().parseFromString(html, 'text/html') : null;
  }

  // ---- drawing -------------------------------------------------------------------------

  function renderDrawer(doc) {
    var cur = document.querySelector('#CartDrawer .drawer__inner');
    var next = doc && doc.querySelector('#CartDrawer .drawer__inner');
    if (!cur || !next) return;
    var scroller = cur.querySelector('cart-drawer-items');
    var scrollTop = scroller ? scroller.scrollTop : 0;
    cur.innerHTML = next.innerHTML;
    var nextScroller = cur.querySelector('cart-drawer-items');
    if (nextScroller) nextScroller.scrollTop = scrollTop;
    var wrap = cur.closest('cart-drawer');
    if (wrap) wrap.classList.toggle('is-empty', !!cur.querySelector('.drawer__inner-empty'));
  }

  function renderBubble(doc) {
    var cur = document.getElementById('cart-icon-bubble');
    var next = doc && doc.querySelector('.shopify-section');
    if (cur && next) cur.innerHTML = next.innerHTML;
  }

  // The cart page: its lines and count, its total, the rewards rail, Pairs well with and
  // the empty state.
  function renderPage(itemsDoc, footDoc) {
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    [[items, itemsDoc], [foot, footDoc]].forEach(function (pair) {
      if (!pair[0] || !pair[1]) return;
      var next = pair[1].querySelector('#' + pair[0].id + ' .js-contents');
      var cur = pair[0].querySelector('.js-contents');
      if (next && cur) cur.innerHTML = next.innerHTML;
    });
    if (foot && footDoc) {
      var curRail = foot.querySelector('[data-kkp-rail]');
      var nextRail = footDoc.querySelector('[data-kkp-rail]');
      if (curRail && nextRail) curRail.innerHTML = nextRail.innerHTML;
      var curUp = foot.querySelector('[data-cr-upsell]');
      var nextUp = footDoc.querySelector('[data-cr-upsell]');
      if (curUp && nextUp) curUp.replaceWith(nextUp);
      else if (curUp) curUp.remove();
      else if (nextUp) {
        var box = foot.querySelector('.cart__footer');
        if (box) box.appendChild(nextUp);
      }
      var nextFoot = footDoc.getElementById('main-cart-footer');
      if (nextFoot) foot.classList.toggle('is-empty', nextFoot.classList.contains('is-empty'));
    }
    var wrap = items && items.closest('cart-items');
    var nextWrap = itemsDoc && itemsDoc.querySelector('cart-items');
    if (wrap && nextWrap) wrap.classList.toggle('is-empty', nextWrap.classList.contains('is-empty'));
  }

  // A tap still waiting for its answer keeps its number on screen through any re-draw.
  function showPending() {
    pending.forEach(function (qty, group) {
      rowsOf(group).forEach(function (row) {
        var input = row.querySelector('.quantity__input');
        if (input) input.value = qty;
      });
    });
  }

  // ---- the screen first -----------------------------------------------------------------
  // What a tap does to its line's price, the total and the gift line is known on the tap,
  // so it is drawn then; Shopify's own drawing replaces it when its answer comes, a second
  // or so later. A line's data-unit / data-unit-was (snippets/kk-cart-line) and a total's
  // data-cents are what the page was drawn with, in paise.
  function money(el, paise) {
    el.textContent = el.textContent.replace(/[\d,]+(\.\d+)?/, function (m, frac) {
      return (paise / 100).toLocaleString('en-IN', { minimumFractionDigits: frac ? 2 : 0, maximumFractionDigits: 2 });
    });
  }

  function paint() {
    var delta = 0;
    pending.forEach(function (qty, group) {
      var rows = rowsOf(group);
      if (!rows.length) return;
      var input = rows[0].querySelector('.quantity__input');
      var drawn = parseInt(input && input.getAttribute('value'), 10) || 0;
      var unit = parseInt(rows[0].dataset.unit, 10) || 0;
      var was = parseInt(rows[0].dataset.unitWas, 10) || 0;
      delta += (qty - drawn) * unit;
      rows.forEach(function (row) {
        row.classList.toggle('kkl--leaving', qty === 0);
        var price = row.querySelector('.kkl__price .price');
        var old = row.querySelector('.kkl__price .cart-item__old-price');
        if (price && unit) money(price, qty * unit);
        if (old && was) money(old, qty * was);
      });
    });
    document.querySelectorAll('.totals__total-value[data-cents]').forEach(function (el) {
      money(el, (parseInt(el.dataset.cents, 10) || 0) + delta);
    });
    if (window.crPaint) window.crPaint(delta);
  }

  function render(sections) {
    if (!sections) return;
    var items = document.getElementById('main-cart-items');
    var foot = document.getElementById('main-cart-footer');
    renderDrawer(parse(sections['cart-drawer']));
    renderBubble(parse(sections['cart-icon-bubble']));
    if (items && foot) {
      renderPage(parse(sections[items.dataset.id]), parse(sections[foot.dataset.id]));
    }
    kk.drawnAt = Date.now();
    showPending();
    if (pending.size) paint();
  }

  // Draw everything from the cart as it is now. A POST that changes nothing: a GET of
  // ?sections= can come back from Shopify's page cache, this cannot. redraw() runs at once
  // (for use inside a queued task); refresh() waits its turn.
  function redraw() {
    return postJSON('/cart/update.js?' + RENDER_FLAG, {
      updates: {},
      sections: sectionIds(),
      sections_url: window.location.pathname,
    }).then(function (res) {
      if (res.ok) render(res.json.sections);
      return res.json;
    });
  }

  function refresh() {
    return queue(redraw);
  }

  // ---- a quantity change ---------------------------------------------------------------

  function rowsOf(group) {
    return document.querySelectorAll('.kkl[data-group="' + group + '"]');
  }

  function showError(group, message) {
    var row = rowsOf(group)[0];
    var text = row && row.querySelector('.cart-item__error-text');
    if (text) {
      text.textContent = message;
      return;
    }
    var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (box) box.textContent = message;
  }

  // Dawn's: the live region speaks the new total for a moment.
  function announce(sections) {
    var status = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!status) return;
    var doc = parse(sections && sections['cart-live-region-text']);
    var next = doc && doc.querySelector('.shopify-section');
    if (next) status.innerHTML = next.innerHTML;
    status.setAttribute('aria-hidden', 'false');
    setTimeout(function () { status.setAttribute('aria-hidden', 'true'); }, 1000);
  }

  // The updates that bring this piece's lines to `desired` in all: a rise goes on its last
  // line, a fall comes off its lines from the last one up.
  function planUpdates(cart, key, vid, desired) {
    var anchor =
      cart.items.find(function (i) { return i.key === key; }) ||
      cart.items.find(function (i) { return String(i.variant_id) === vid && !isGift(i); });
    if (!anchor) return {};
    var lines = cart.items.filter(function (i) {
      return i.variant_id === anchor.variant_id && !isGift(i) && sameProperties(i, anchor);
    });
    var total = lines.reduce(function (sum, i) { return sum + i.quantity; }, 0);
    var updates = {};
    if (desired > total) {
      var last = lines[lines.length - 1];
      updates[last.key] = last.quantity + (desired - total);
    } else {
      var cut = total - desired;
      for (var n = lines.length - 1; n >= 0 && cut > 0; n--) {
        var take = Math.min(cut, lines[n].quantity);
        updates[lines[n].key] = lines[n].quantity - take;
        cut -= take;
      }
    }
    return updates;
  }

  // After an answer, or after a failure: no spinner, and with no newer tap waiting the box
  // shows what the page was last drawn with.
  function settle(group) {
    rowsOf(group).forEach(function (row) {
      row.querySelectorAll('.loading__spinner').forEach(function (s) { s.classList.add('hidden'); });
      var input = row.querySelector('.quantity__input');
      if (input && !pending.has(group)) input.value = input.getAttribute('value');
    });
  }

  // A keyboard user keeps their place: the same control on the re-drawn line, else the
  // first line's name, else the empty cart's link.
  function restoreFocus(group, control) {
    if (!control || (document.activeElement && document.activeElement !== document.body)) return;
    var row = rowsOf(group)[0];
    var target =
      (row && control !== 'remove' && row.querySelector('[name="' + control + '"]')) ||
      document.querySelector('cart-drawer.active .kkl__name, #main-cart-items .kkl__name') ||
      document.querySelector('cart-drawer.active .drawer__inner-empty a, .cart__warnings a');
    if (!target) return;
    var drawer = target.closest('cart-drawer');
    if (drawer && typeof trapFocus === 'function') trapFocus(drawer, target);
    else target.focus({ preventScroll: true });
  }

  // An earlier tap left the gift to this one (it was still on its way); this one failed, so
  // the gift is settled from the cart the error redraw came back with.
  function giftAfterFailure(cart) {
    if (!pending.size && cart && cart.items && window.crGiftFrom) return window.crGiftFrom(cart);
  }

  function commit(group, info) {
    if (!pending.has(group)) return Promise.resolve();
    var desired = pending.get(group); // the latest tap, read when its turn comes
    var done = function () { if (pending.get(group) === desired) pending.delete(group); };
    return getCart()
      .then(function (cart) {
        // kk_gift: the free-gift sync takes its cue from this answer below, not from its own
        // watch on cart requests (snippets/cart-rewards-bar)
        return postJSON('/cart/update.js?' + GIFT_FLAG, {
          updates: planUpdates(cart, info.key, info.vid, desired),
          sections: sectionIds(),
          sections_url: window.location.pathname,
        });
      })
      .then(function (res) {
        done();
        if (!res.ok) {
          var message = res.json.description || res.json.message || window.cartStrings.error;
          return redraw().then(function (now) { showError(group, message); return giftAfterFailure(now); });
        }
        render(res.json.sections);
        announce(res.json.sections);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: res.json, variantId: info.vid });
        // The gift follows from this same answer, in this same turn: no wait, no second read.
        // A newer tap still on its way brings its own answer, and the gift is settled from that.
        if (!pending.size && window.crGiftFrom) return window.crGiftFrom(res.json);
      })
      .catch(function (error) {
        console.error('[kk-cart] quantity change failed', error);
        done();
        return redraw().catch(function () {}).then(function (now) { showError(group, window.cartStrings.error); return giftAfterFailure(now); });
      })
      .then(function () {
        settle(group);
        restoreFocus(group, info.control);
      });
  }

  // A piece's new quantity. Each piece has its own short wait, so taps in a row go as one
  // change, and two pieces tapped together both go.
  var timers = new Map();
  var infos = new Map();
  function send(group) {
    clearTimeout(timers.get(group));
    timers.delete(group);
    var info = infos.get(group);
    queue(function () { return commit(group, info); });
  }

  function request(row, qty, wait, control) {
    var group = row.dataset.group;
    infos.set(group, { key: row.dataset.key, vid: row.dataset.variantId, control: control });
    pending.set(group, qty);
    showPending();
    paint();
    rowsOf(group).forEach(function (r) {
      r.querySelectorAll('.loading__spinner').forEach(function (s) { s.classList.remove('hidden'); });
      var text = r.querySelector('.cart-item__error-text');
      if (text) text.textContent = '';
    });
    clearTimeout(timers.get(group));
    timers.set(group, setTimeout(function () { send(group); }, wait));
  }

  // Before the shopper leaves for checkout: taps still in their short wait go now, and the
  // gift is put right from a fresh read of the cart, so checkout opens on the bag the screen
  // showed — the tapped quantity and the gift it earned. Never longer than `limit`: a slow
  // answer must not keep anyone from paying.
  function settleAll(limit) {
    Array.from(timers.keys()).forEach(send);
    var done = queue(function () {
      return getCart().then(function (cart) { return window.crGiftFrom ? window.crGiftFrom(cart) : null; });
    });
    return Promise.race([done.catch(function () {}), new Promise(function (r) { setTimeout(r, limit || 6000); })]);
  }

  // Secure checkout (drawer) and Checkout (cart page) wait for settleAll, then submit as
  // they were going to.
  var leaving = false;
  document.addEventListener(
    'submit',
    function (event) {
      var button = event.submitter;
      if (leaving || !button || !button.classList || !button.classList.contains('kk-checkout')) return;
      event.preventDefault();
      var form = event.target;
      if (window.kkBusy) window.kkBusy(button, true);
      settleAll().then(function () {
        leaving = true;
        // the drawer may have been redrawn meanwhile (the gift went in): the button and its
        // form are found again by id, the ones tapped may no longer be in the page
        var nowButton = (button.id && document.getElementById(button.id)) || button;
        var nowForm = (form.id && document.getElementById(form.id)) || form;
        if (nowButton.disabled) {
          // the bag was emptied while it waited: nothing to check out
          leaving = false;
          if (window.kkBusy) window.kkBusy(nowButton, false);
          return;
        }
        if (window.kkBusy) window.kkBusy(nowButton, true);
        try {
          nowForm.requestSubmit(nowButton);
        } catch (error) {
          nowButton.click();
        }
      });
    },
    true
  );
  window.addEventListener('pageshow', function (event) { if (event.persisted) leaving = false; });

  // The quantity box — "+", "−" or a typed number — taken here instead of by Dawn's cart.js,
  // the moment it changes: a re-draw a moment later keeps the tapped number in the box, and
  // the next tap counts on from it.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('quantity__input')) return;
      var row = input.closest('.kkl');
      if (!row || !row.dataset.group) return;
      event.stopPropagation();
      var qty = parseInt(input.value, 10);
      var max = parseInt(input.max, 10);
      if (isNaN(qty) || qty < 0) {
        input.value = input.getAttribute('value');
        return;
      }
      if (!isNaN(max) && qty > max) qty = max;
      input.value = qty;
      var box = input.closest('quantity-input');
      if (box && box.validateQtyRules) box.validateQtyRules();
      var active = document.activeElement;
      var control = active && row.contains(active) ? active.getAttribute('name') : null;
      request(row, qty, typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300, control);
    },
    true
  );

  // Dawn's remove button (assets/cart.js) still calls this. `this` is the cart the tap
  // happened in — possibly one a re-draw has since detached — so the row is looked up
  // inside it, never by its position in the page.
  CartItems.prototype.updateQuantity = function (line, quantity) {
    var row = this.querySelector('#CartDrawer-Item-' + line) || this.querySelector('#CartItem-' + line);
    if (!row || !row.dataset.group) return;
    var active = document.activeElement;
    var control = active && row.contains(active) ? 'remove' : null;
    request(row, Math.max(0, parseInt(quantity, 10) || 0), 0, control);
  };

  var kk = (window.kkCart = { queue: queue, refresh: refresh, render: render, sectionIds: sectionIds, settle: settleAll, RENDER_FLAG: RENDER_FLAG, GIFT_FLAG: GIFT_FLAG, drawnAt: 0 });
})();

/* Gift wrap (snippets/kk-gift-wrap): the tick adds or removes the ₹199 line; the message is a
   cart attribute. The screen changes on the tap and the write follows in the background, without
   a redraw: the wrap touches neither the lines shown nor the gift ladder, only the total, and a
   redraw would close a message being typed. Listened for on the way down, because the row stops
   "change" going up: a raw change event inside the drawer is read by cart.js as a quantity change. */
(function () {
  if (window.__kkWrapInit) return;
  window.__kkWrapInit = true;
  var JSON_POST = { 'Content-Type': 'application/json' };
  var timer = null;
  function saveMessage(text) {
    return fetch('/cart/update.js', { method: 'POST', keepalive: true, headers: JSON_POST, body: JSON.stringify({ attributes: { 'Gift message': text } }) });
  }
  function moveTotal(by) {
    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      // the total a quantity tap counts from (data-cents) moves with it, since no redraw follows
      if (el.dataset.cents) el.dataset.cents = String((parseInt(el.dataset.cents, 10) || 0) + by * 100);
      el.textContent = el.textContent.replace(/[\d,]+(\.\d+)?/, function (n) {
        return (parseFloat(n.replace(/,/g, '')) + by).toLocaleString('en-IN');
      });
    });
  }
  function show(input, on) {
    var box = input.closest('[data-kk-wrap]');
    input.checked = on;
    box.classList.toggle('is-on', on);
    moveTotal((on ? 1 : -1) * Number(box.dataset.price));
  }
  function write(input) {
    var kk = window.kkCart, on = input.checked;
    var box = input.closest('[data-kk-wrap]'), err = box.querySelector('.kkgw__err');
    if (err) err.hidden = true;
    input.checked = !on;
    show(input, on);
    function task() {
      var call = on
        ? fetch('/cart/add.js', { method: 'POST', headers: JSON_POST, body: JSON.stringify({ items: [{ id: Number(box.dataset.variant), quantity: 1 }] }) })
        : fetch('/cart/change.js', { method: 'POST', headers: JSON_POST, body: JSON.stringify({ id: box.dataset.key, quantity: 0 }) });
      return call
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (json) {
          box.dataset.key = on ? json.items[0].key : '';
          return on ? null : saveMessage('');
        })
        .catch(function () { show(input, !on); if (err) err.hidden = false; });
    }
    if (kk) kk.queue(task); else task();
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('.kkgw__input')) write(t);
    if (t.matches && t.matches('.kkgw__msg')) { clearTimeout(timer); saveMessage(t.value); }
  }, true);
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('.kkgw__msg')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { saveMessage(t.value); }, 600);
  });
})();
